// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/payment/stylesheet/index.scss
 ** module id = 458
 ** module chunks = 1
 **/